import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { getInset } from 'react-native-safe-area-view';
import { UserProfile, WorkoutSettings } from '../../../../gym-core/lib';
import { Gym } from '../../../../models/src';
import theme, { ThemeType } from '../../theme';
import { defaultScale } from '../../utils/scaling';
import {
  PersonaliseSetupWarning,
  PersonaliseWorkoutFooter,
} from './personaliseWorkoutSteps';
import { PersonaliseWorkoutSetup } from './personaliseWorkoutSteps/PersonaliseWorkoutSetup';
import { PersonaliseSetupScreens } from './personaliseWorkoutSteps/types';

interface IProps {
  gym: Gym;
  isSavingSettings: boolean;
  personaliseSetupWarning: PersonaliseSetupWarning;
  workoutSettings: WorkoutSettings;
  userProfile: UserProfile;
  currentPersonaliseSetupScreen: PersonaliseSetupScreens;
  closeSetupAndResetOverviewScreen(): void;
  goBack(): void;
  clearWarning(): void;
  saveAndClose(): void;
  openPersonaliseSetupScreen(): void;
  onCompleteSettingChange(
    settings: WorkoutSettings,
    shouldSaveDefaultEquipment: boolean,
  );
}
const bottomInset = Platform.OS !== 'web' ? getInset('bottom', false) : 0;
const orientation = 'PORTRAIT';
export const WorkoutOverview: React.FC<IProps> = ({
  gym,
  workoutSettings,
  userProfile,
  closeSetupAndResetOverviewScreen,
  isSavingSettings,
  personaliseSetupWarning,
  currentPersonaliseSetupScreen,
  goBack,
  clearWarning,
  saveAndClose,
  openPersonaliseSetupScreen,
  onCompleteSettingChange,
}) => {
  return (
    <View style={style.container}>
      <PersonaliseWorkoutSetup
        themeType={ThemeType.light}
        orientation={orientation}
        gym={gym}
        workoutSettings={workoutSettings}
        userProfile={userProfile}
        onCompleteSettingChange={onCompleteSettingChange}
      />

      <PersonaliseWorkoutFooter
        themeType={ThemeType.light}
        orientation={orientation}
        currentPersonaliseSetupScreen={currentPersonaliseSetupScreen}
        workoutSettingsIsUpdating={isSavingSettings}
        personaliseSetupWarning={personaliseSetupWarning}
        settingsChanged={true}
        goBack={goBack}
        saveAndClose={saveAndClose}
        closeSetupAndResetOverviewScreen={closeSetupAndResetOverviewScreen}
        clearWarning={clearWarning}
        openPersonaliseSetupScreen={openPersonaliseSetupScreen}
        containerStyle={style.footerContainer}
        workoutSettings={workoutSettings}
      />
    </View>
  );
};

const style = StyleSheet.create({
  container: {
    flex: 1,
  },
  tile: {
    backgroundColor: theme.WHITE,
    marginTop: defaultScale(10),
    paddingHorizontal: defaultScale(18),
    paddingVertical: defaultScale(22),
  },
  buttonsContainer: {
    flexDirection: 'row',
  },

  footerContainer: {
    paddingHorizontal: defaultScale(18),
    paddingBottom: defaultScale(15 + bottomInset),
  },
  tileHeadingStyle: {
    ...theme.textStyle.heading2,
    marginBottom: defaultScale(18),
  },
});
